import { trigger, transition, style, query, animateChild, group, animate, sequence } from '@angular/animations';

export const routeTransitionAnimations = trigger('routeAnimations', [
  transition('ready => slideStand', [
    group([
      query(`#mainOutlet + stand stand-header .slide-hide,
              #mainOutlet + stand info-bar`, [
        style({visibility: 'hidden'})
      ], {optional: true}),
      query(`#mainOutlet + stand stand-header #header-content,
            #mainOutlet + stand #standContent + *`, [
        style({transform: 'translateX(0%)'}),
        animate('800ms ease-out', style({transform: 'translateX({{leave}}%)', opacity: 0}))
      ], {optional: true}),
      query(`stand + stand`, [
        style({position: 'absolute', top: '64px', left: 0, width: '100vw', height: 'calc(100vh - 64px)'})
      ], {optional: true}),
      query(`stand + stand stand-header .slide-opacity`, [
        style({opacity: 0}),
        animate('800ms ease-out', style({opacity: 1}))
      ], {optional: true}),
      query(`stand + stand stand-header #header-content`, [
        style({transform: 'translateX({{enter}}%)', opacity: 0}),
        animate('800ms ease-out', style({transform: 'translateX(0%)', opacity: 1}))
      ], {optional: true}),
      query(`stand + stand #standContent + *`, [
      style({transform: 'translateX({{enter}}%)', opacity: 0, width: '100vw'}),
      animate('800ms ease-out', style({transform: 'translateX(0%)', opacity: 1, width: '100%'}))
      ], {optional: true})
    ]),
  ], { params: { enter: 100, leave: -100 }})
]);
